import React from 'react';
import PropTypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import MobileNullView from './MobileNullView';
import DesktopNullView from './DesktopNullView';

const ProjectsNullView = ({ componentId, isCompactView }) => {
  const { ref, clickID } = useImpression({
    data: {
      component: 'ProjectsNullView',
      name: 'ProjectsNullView',
      id: componentId || '',
      position: 1,
      type: 'content'
    }
  });

  return (
    <div
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
    >
      {isCompactView ? (
        <MobileNullView componentId={componentId} />
      ) : (
        <DesktopNullView componentId={componentId} />
      )}
    </div>
  );
};

ProjectsNullView.propTypes = {
  componentId: PropTypes.string,
  isCompactView: PropTypes.bool
};

ProjectsNullView.defaultProps = {
  componentId: '',
  isCompactView: true
};

export default ProjectsNullView;
